import gql from 'graphql-tag';

export const getMultiBuildingServiceRequestFilterAttributesQuery = gql`
  query getMultiBuildingServiceRequestFilterAttributesQuery($channelIds: [UUID!]) {
    multiBuildingServiceRequestFilterAttributes(channelIds: $channelIds) {
      companies {
        name
        id
      }
      categories
      statuses
      issues
      locations
      assignees {
        name
        id
      }
      equipment {
        name
        id
      }
      historyStatuses
    }
  }
`;
